<template lang="pug">
	.footer
		section.section.section--dark-grey
			.section__container.section__container--smaller
				slot(name="site-links")
				.copyright
					p.copyright__text Copyright {{ currentYear }} OTP Ingatlanpont
</template>
<script>
export default {
	computed: {
		currentYear() {
			return new Date().getFullYear();
		}
	}
}
</script>
